import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-textarea',
    template: `
        <mat-form-field class="demo-full-width" [formGroup]="group" appearance="outline">
          <mat-label> {{ field.label }} </mat-label>
          <textarea matInput [formControlName]="field.key" [placeholder]="field.label" ></textarea>
          @for (validation of field.validations; track validation) {
            <ng-container ngProjectAs="mat-error">
              @if (group.get(field.key).hasError(validation.name)) {
                <mat-error>{{validation.message}}</mat-error>
              }
            </ng-container>
          }
        </mat-form-field>
        `,
    // host: {'class': 'col-md-6'},
    styles: [],
    standalone: false
})
export class TextareaComponent implements OnInit {
    field: FieldConfig;
    group: UntypedFormGroup;
    // @HostBinding('class') rowClass = 'col-md-6';
    constructor() { }
    ngOnInit() {


        //  this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
    }
}
